import React, { useEffect } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import FeedForm from "../Components/Form/FeedForm";
import { Helmet } from "react-helmet-async";

const Feedback = () => {
  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Feedback | Aneeq Ullah Khan</title>
        <meta
          name="description"
          content="This is the feedback page you can also give your feedback how's you like my website, projects and services by filling the form."
        />
        <meta
          name="keywords"
          content="Aneeq Ullah Khan, Aneeq Ullah Khan Feedback, Feedback Aneeq Ullah Khan, Aneeq Khan Feedback"
        />
      </Helmet>
      <Navbar />
      <div className="container mt-5 mb-5">
        <h4 className="card-title text-center">
          Your Feedback Is Important For Me To Enhance This Site
        </h4>
        <FeedForm />
      </div>
      <br />
      <Footer />
    </React.Fragment>
  );
};

export default Feedback;
